import type { FC } from 'react';
import { Modal, Tabs } from 'antd';
import { useTranslation } from 'react-i18next';

import { usePermissionsContext } from 'src/util/context/PermissionsContext';

import { PermissionsGroupsList } from './components/PermissionsGroupsList';
import { PermissionsUsersList } from './components/PermissionsUsersList';
import { PortfolioDefaultPermission } from './components/PortfolioDefaultPermission';

export const PermissionsManagementModal: FC = () => {
  const { permissionsModalState, setPermissionsModalState } =
    usePermissionsContext();
  const { t } = useTranslation('permissions');

  return (
    <Modal
      open={permissionsModalState?.visible ?? false}
      onCancel={() => setPermissionsModalState()}
      onOk={() => setPermissionsModalState()}
      destroyOnClose
      okText={t('Done')}
      width="50%"
      title={t(`Manage permissions for ${permissionsModalState?.entity}`)}
    >
      {permissionsModalState?.entity === 'portfolio' && (
        <PortfolioDefaultPermission />
      )}
      <Tabs
        items={[
          {
            key: 'permission-groups',
            label: t('Groups'),
            children: <PermissionsGroupsList />,
          },
          {
            key: 'permission-users',
            label: t('Users'),
            children: <PermissionsUsersList />,
          },
        ]}
      />
    </Modal>
  );
};
